export const ROUTE_MAP: Record<string, string> = {
  "Categorias": "/categorias",
  "DetalleReceta": "/detalle-receta",
  "EntradaApp": "/entrada-app",
  "Ingredientes": "/ingredientes",
  "ListadoRecetas": "/listado-recetas",
  "ListadoSoloLite": "/listado-solo-lite",
  "LoginColl": "/login-coll",
  "Pasos": "/pasos",
  "Recetas": "/recetas",
  "Empresas": "/empresas",
  "Usuarios": "/usuarios",
} as const;
